<template>
  <path
    d="M5.5 4.50025C5.5 3.11948 6.61934 2 8 2C9.38066 2 10.5 3.11947 10.5 4.50023L10.5 6.5C10.5 6.77614 10.7239 7 11 7C11.2761 7 11.5 6.77615 11.5 6.5L11.5 4.50023C11.5 2.56729 9.93305 1 8 1C6.06695 1 4.5 2.5673 4.5 4.50025L4.5 6.5C4.5 6.77614 4.72385 7 5 7C5.27614 7 5.5 6.77615 5.5 6.5L5.5 4.50025Z"
    fill="#F9F9F9" />
  <path
    d="M5.5 9.5C5.50001 9.22386 5.27615 9 5.00001 9C4.72386 9 4.50001 9.22385 4.5 9.5L4.5 11.4998C4.5 13.4327 6.06695 15 8 15C9.93305 15 11.5 13.4327 11.5 11.4998L11.5 9.5C11.5 9.22386 11.2761 9 11 9C10.7239 9 10.5 9.22385 10.5 9.5L10.5 11.4998C10.5 12.8805 9.38066 14 8 14C6.61934 14 5.5 12.8805 5.5 11.4998L5.5 9.5Z"
    fill="#F9F9F9" />
</template>
